import { createFileRoute } from "@tanstack/react-router";
import { RegionalHubPage, hubSchemaScripts, seoHead } from "@/components/hubs/HubPages";
import { REGIONAL_HUBS } from "@/lib/regionalHubs";

const DATA = REGIONAL_HUBS.find((x) => x.path === "/south-metro-contractor-marketing")!;
const DESC = "Local websites, SEO and Google Maps for contractors in Castle Rock, Parker, Highlands Ranch, Lone Tree, Littleton, Greenwood Village and Centennial.";

export const Route = createFileRoute("/south-metro-contractor-marketing")({
  head: () => seoHead("/south-metro-contractor-marketing", "Contractor Marketing Castle Rock, Parker & Highlands Ranch", DESC, "website", hubSchemaScripts(DATA, DESC)),
  component: () => <RegionalHubPage hub={DATA} />,
});
